import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { UploadButton } from "@/components/UploadButton";
import { toast } from "sonner";

export default function AdminBonus() {
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    title: "",
    description: "",
    image: "",
  });

  const loadData = async () => {
    try {
      const { data } = await api.get("/admin/master/bonus");
      setItems(data);
    } catch {
      toast.error("Gagal memuat data bonus");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

const saveBonus = async () => {
  try {

    if (editingId) {

      await api.patch(
        `/admin/master/bonus/${editingId}`,
        form
      );

      toast.success("Bonus berhasil diperbarui");

    } else {

      await api.post(
        "/admin/master/bonus",
        form
      );

      toast.success("Bonus berhasil ditambahkan");
    }

    setForm({
      title: "",
      description: "",
      image: "",
    });

    setEditingId(null);

    loadData();

  } catch {
    toast.error("Gagal menyimpan bonus");
  }
};

  const deleteBonus = async (id) => {
    if (!window.confirm("Hapus bonus ini?")) return;

    try {
      await api.delete(`/admin/master/bonus/${id}`);
      toast.success("Bonus berhasil dihapus");
      loadData();
    } catch {
      toast.error("Gagal menghapus bonus");
    }
  };

const editBonus = (item) => {

  setEditingId(item.id);

  setForm({
    title: item.title || "",
    description: item.description || "",
    image: item.image || "",
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">
          Master Bonus
        </h1>
      </div>

      <div className="grid gap-3">

        <input
          className="border rounded px-3 py-2"
          placeholder="Bonus Title"
          value={form.title}
          onChange={(e) =>
            setForm({
              ...form,
              title: e.target.value,
            })
          }
        />

        <textarea
          rows={3}
          className="border rounded px-3 py-2"
          placeholder="Description"
          value={form.description}
          onChange={(e) =>
            setForm({
              ...form,
              description: e.target.value,
            })
          }
        />

        <div className="space-y-2">
          <UploadButton
            label="Upload Bonus Image"
            onUploaded={(url) =>
              setForm({
                ...form,
                image: url,
              })
            }
          />

          {form.image && (
            <img
              src={form.image}
              alt="Bonus Preview"
              className="h-32 w-full object-cover rounded border"
            />
          )}
        </div>

      </div>

      <button
        onClick={saveBonus}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
      {editingId
  ? "Update Bonus"
  : "Tambah Bonus"}
      </button>
{editingId && (
  <button
    onClick={() => {

      setEditingId(null);

      setForm({
        title: "",
        description: "",
        image: "",
      });

    }}
    className="ml-3 border px-4 py-2 rounded"
  >
    Batal
  </button>
)}
      <table className="w-full border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Title</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className="border p-2">
                {item.title}
              </td>

<td className="border p-2 space-x-3">

  <button
    onClick={() => editBonus(item)}
    className="text-blue-600 font-medium"
  >
    Edit
  </button>

  <button
    onClick={() => deleteBonus(item.id)}
    className="text-red-600 font-medium"
  >
    Hapus
  </button>

</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
